export default __webpack_public_path__ + "static/media/kaapi-1.e9a3e1ab.jpg";